import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Storage } from '@ionic/storage';
import { App, ToastController } from 'ionic-angular';
import * as myGlobal from '../../assets/global';
import { Observable } from 'rxjs';
import { ToastHelper } from '../../helpers/toastr-helper';

/**
 * Api is a generic REST Api handler. Set your API url first.
 */
@Injectable()
export class Api {
    // url: string = 'https://www.matchabout.com/soa-1/services';
    url: string = myGlobal.url;

    toastCtrl: any;

    constructor(
        public http: HttpClient,
        public storage: Storage,
        public app: App,
        public injector: Injector
    ) {
        this.toastCtrl = this.injector.get(ToastController);
    }

    get(endpoint: string, params?: any, reqOpts?: any) {
        if (!reqOpts) {
            reqOpts = {
                params: new HttpParams(),
            };
        }

        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new HttpParams();
            for (let k in params) {
                reqOpts.params = reqOpts.params.set(k, params[k]);
            }
        }

        return this.http.get(this.url + '/' + endpoint, reqOpts);
    }

    downloadFile(fileUrl: string, params?: any, reqOpts?: any) {

        let headers = new HttpHeaders();
        headers = headers.set('Accept', 'application/pdf')

        return this.http.get(fileUrl, 
            { headers: headers, responseType: 'blob' });
    }

    post(endpoint: string, body: any, reqOpts?: any) {
        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    }

    getNoSession(endpoint: string, params?: any, reqOpts?: any) {
        if (!reqOpts) {
            reqOpts = {
                params: new HttpParams(),
            };
        }

        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new HttpParams();
            for (let k in params) {
                reqOpts.params = reqOpts.params.set(k, params[k]);
            }
        }
        return this.http.get(this.url + '/' + endpoint, reqOpts);
    }

    async getNoSessionHeaders(endpoint: string, params?: any, reqOpts?: any) {
        if (!reqOpts) {
            reqOpts = {
                params: new HttpParams(),
            };
        }

        // Support easy query params for GET requests
        if (params) {
            reqOpts.params = new HttpParams();
            for (let k in params) {
                reqOpts.params = reqOpts.params.set(k, params[k]);
            }
        }

        return this.http.get(this.url + '/' + endpoint, reqOpts);
    }

    postLogin(endpoint: string, body: any, reqOpts?: any) {
        return this.http.post(this.url + '/' + endpoint, body, reqOpts);
    }

    put(endpoint: string, body: any, reqOpts?: any) {
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    }

    async delete(endpoint: string, reqOpts?: any) {
        return this.http.delete(this.url + '/' + endpoint, reqOpts);
    }

    patch(endpoint: string, body: any, reqOpts?: any) {
        return this.http.put(this.url + '/' + endpoint, body, reqOpts);
    }

    private handleError(response: any) {

        let message = response.error.message;

        switch (response.error.status) {
            case 500:
                message = "Something went wrong. Please contact system administrator."
        }

        ToastHelper.Show(this.toastCtrl, message);

        return Observable.throw(response.error);
    }

    async fileUpload(
        endpoint: string,
        fileData: any,
        extraData?: object,
        reqOpts?: any
    ) {
        const formData: FormData = new FormData();
        formData.append('fileData', fileData);
        if (extraData) {
            for (let key in extraData) {
                // iterate and set other form data
                formData.append(key, extraData[key]);
            }
        }

        return this.http.post(this.url + '/' + endpoint, formData, reqOpts);
    }

    getUser(): Promise<any> {
        const user = JSON.parse(localStorage.getItem('user'));
        return user;
    }
}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts